








































































































import { Component, Vue, Mixins } from 'vue-property-decorator';

// Mixin
import RolesMixin from '@/mixins/Staff/UserManagement/Roles';

@Component
export default class IctRoles extends Mixins(RolesMixin) {}
